module.exports = __webpack_public_path__ + "img/arrow_up_gray.f145a1b7.svg";